import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

export interface RenewalPortfolioCardThemeProps {
  productsLength: number;
}

const styles: ComponentStylesProps<RenewalPortfolioCardThemeProps> = {
  multiProductCard: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '3.6rem',
  },
  productsList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(30rem, 1fr))',
    gap: '2rem',
    paddingBottom: '3rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    marginBottom: '1rem',
  },
  multiProductWrapper: {
    display: 'grid',
    gap: '1.5rem',
    backgroundColor: colors.neutral.white,
    borderRadius: '1.5rem',
    padding: '2rem',
    boxSizing: 'border-box',
    border: `0.1rem solid ${colors.neutral[300]}`,
    gridAutoRows: 'auto 1fr',
  },
  productTitle: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.neutral[900],
    margin: 0,
    letterSpacing: '0.02em',
    fontWeight: '400',
  },
  singleProductPortfolioTitle: {
    alignSelf: 'self-start',
    marginTop: '2rem',
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[200]}`,
  },
  ratesItem: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1rem',
    alignItems: 'center',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    letterSpacing: '0.02em',
    '& span:first-child': {
      overflowWrap: 'break-word',
      maxWidth: '20rem',
    },
    '& span:last-child': {
      fontWeight: 700,
      color: colors.green[600],
    },
    '&:not(:last-child)': {
      marginBottom: '0.8rem',
    },
  },
  downloadButton: ({ productsLength }) => ({
    padding: 0,
    marginRight: productsLength > 1 && '1rem',
    width: 'fit-content',
  }),
  renewalProductHeader: ({ productsLength }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
    marginTop: 0,
    marginLeft: productsLength === 1 ? '0rem' : '0.5rem',
  }),
  renewalProductCard: ({ productsLength }) => ({
    position: 'relative',
    border: `0.1rem solid ${colors.neutral[200]}`,
    borderRadius: '1.5rem',
    padding: productsLength === 1 ? '2rem' : '4rem 3rem 2rem',
    boxSizing: 'border-box',
    width: '100%',
    display: 'grid',
    gap: '1.5rem',
    gridAutoRows: productsLength === 1 ? '0 auto 1fr auto' : 'auto auto auto',
  }),
  renewalCardContent: {
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
  },
  renewalRatesList: {
    maxWidth: '24rem',
    padding: '0',
    margin: 0,
  },
  multiProductRatesWrapper: {
    paddingTop: '1.5rem',
    borderTop: `0.1rem solid ${colors.neutral[300]}`,
  },
  renewalTag: {
    position: 'absolute',
    margin: 0,
    width: '100%',
    top: '-0.1rem',
    left: 0,
    padding: '0.8rem 0',
    color: colors.neutral.white,
    fontSize: '1.4rem',
    textAlign: 'center',
    lineHeight: '2rem',
    borderRadius: '1.5rem 1.5rem 0 0',
    backgroundColor: colors.neutral[300],
  },
  ratesTitle: {
    font: { size: '1.4rem', lineHeight: '2rem' },
    fontWeight: 700,
    letterSpacing: '0.02em',
    color: colors.neutral[700],
    textTransform: 'uppercase',
    margin: 0,
    marginBottom: '1.5rem',
  },
  ratesMessage: {
    fontSize: '1.4rem',
    color: colors.neutral[900],
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '1rem',
    },
  },
  addBenefitButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
